import { useDialog } from "src/components/Modalservice/Dialogservice";
import React from "react";
import { useI18n } from "src/utils/lni18n";
import { ConfirmationButtons, ConfirmationDialog, ConfirmationOptions } from "./ConfirmationDialog";


export const useConfirm = () => {
    const dialogPortal = useDialog();
    const { languageService: t } = useI18n();

    async function confirm(
            size: "md" | "sm" | "xl" | "lg" | "recorder" | undefined, 
            title: string, 
            message: string | React.ReactNode) {

         const p:Promise<boolean> = dialogPortal({
                   factory: (onSubmit, onCancel) => {
                       const dprops: ConfirmationOptions = {
                           className: "",
                           title: title,
                           message: message,
                           languageService: t,
                           show: true,
                           onClose: onCancel,
                           onSubmit: onSubmit,
                           buttons: ConfirmationButtons.YesNo
                       }
                       return <ConfirmationDialog {...dprops} />
                   },
                   size: size
               });
               return p;
    }

    return confirm;

}